<template>
  <div v-loading="loading">
    <div class="title">题目校对</div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">任务信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">任务名称：</span>
            <span class="hidden-redundant" @click="dialogDesVisible = true">
              <el-link type="primary" :underline="false">{{
                taskInfo.name
              }}</el-link>
            </span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">状态：</span>
            <span>{{ taskInfo.status_label }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">价格：</span>
            <span>{{ taskInfo.total_price }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">语言：</span>
            <span>{{ taskInfo.langs_label }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">题目数量：</span>
            <span>{{ taskInfo.questions_count }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">截止时间：</span>
            <span>{{ taskInfo.end_at }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="hover" class="mt-12" v-loading="proofreadLoading">
      <div slot="header" class="card-header">
        <span class="brand-color">校对区</span>
        <el-button
          type="primary"
          v-if="
            authPermissions.includes(
              'question.api.fuwu_admin.skill_question_verify.question.show'
            )
          "
          :loading="btnLoading"
          @click="handleOpenDrawer"
        >
          题目列表
        </el-button>
      </div>
      <el-alert
        class="mb-12"
        show-icon
        :title="originInfo.status_label"
        :type="originInfoTipsType"
      >
      </el-alert>
      <div class="proofread-card-container">
        <el-card class="origin-card">
          <div slot="header">
            <span class="brand-color">原题（{{ originInfo.id }}）</span>
          </div>
          <div class="question-info">
            <div class="question-item">
              <div class="question-label">题干：</div>
              <Markdown
                class="min-h-154"
                :value.sync="originInfo.stem"
                defaultOpen="edit"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                option="editreadmodel"
                disabled
              ></Markdown>
            </div>
            <div
              v-for="(optionItem, optionIndex) in originInfo.options"
              :key="optionIndex"
              class="question-item"
            >
              <div class="question-label">选项{{ optionIndex + 1 }}：</div>
              <Markdown
                class="min-h-154"
                :value.sync="optionItem.option"
                defaultOpen="edit"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                option="editreadmodel"
                disabled
              ></Markdown>
            </div>
            <div class="question-item">
              <div class="question-label">解析：</div>
              <Markdown
                class="min-h-154"
                :value.sync="originInfo.analysis"
                defaultOpen="edit"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                option="editreadmodel"
                disabled
              ></Markdown>
            </div>
          </div>
        </el-card>
        <el-card class="proofread-card">
          <div slot="header">
            <span class="brand-color"
              >{{ taskInfo.langs_label }}译文（{{ originInfo.id }}）</span
            >
          </div>
          <el-form
            class="mt-12"
            :model="proofreadInfo"
            :rules="proofreadRules"
            label-position="top"
            ref="proofreadInfo"
          >
            <el-form-item
              label="题干："
              prop="stem"
              :show-message="false"
              label-width="80px"
            >
              <div>
                <Markdown
                  class="min-h-154"
                  :value.sync="proofreadInfo.stem"
                  defaultOpen="edit"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  option="proofreadmodel"
                ></Markdown>
              </div>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in proofreadInfo.options"
              :key="index"
              label-width="80px"
              :label="`选项 ${index + 1}：`"
              :prop="`options[${index}].option`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
            >
              <Markdown
                class="min-h-154"
                :value.sync="option.option"
                defaultOpen="edit"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                option="proofreadmodel"
              ></Markdown>
            </el-form-item>
            <el-form-item
              label="解析："
              prop="analysis"
              :show-message="false"
              label-width="80px"
            >
              <Markdown
                class="min-h-154"
                :value.sync="proofreadInfo.analysis"
                defaultOpen="edit"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                option="proofreadmodel"
              ></Markdown>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <el-card class="mt-12" shadow="hover" v-if="verify_histories.length">
        <div slot="header" class="card-header">
          <span>拒绝历史</span>
        </div>
        <el-form label-width="90px" label-position="left">
          <el-row :gutter="20">
            <el-col
              v-for="(item, index) in verify_histories"
              :key="index"
              :span="12"
            >
              <el-card class="mr-12" shadow="hover">
                <el-form-item label="拒绝人：">
                  {{ item.auditor_by }}
                </el-form-item>
                <el-form-item label="拒绝时间：">
                  {{ item.created_at }}
                </el-form-item>
                <el-form-item label="拒绝原因：">
                  <Markdown
                    class="min-h-154"
                    :value.sync="item.reject_reason"
                    defaultOpen="preview"
                    space="_for_kungfu_sub_project"
                    folder="fuwu"
                    option="editreadmodel"
                    disabled
                  ></Markdown>
                </el-form-item>
              </el-card>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <div
        v-if="
          taskInfo.status == 2 &&
            originInfo.status !== 4 &&
            authPermissions.includes(
              'question.api.fuwu_admin.skill_question_verify.question.verify'
            )
        "
        class="finish-btn-container"
      >
        <zhu-button
          class="w-200"
          text="完成"
          :shadow="true"
          type="primary"
          :loading="btnLoading"
          @click="proofreadFinish"
        >
        </zhu-button>
      </div>
    </el-card>
    <el-dialog
      class="skill-task-dialog"
      :visible.sync="dialogDesVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="taskInfo.description"></markdown-it>
    </el-dialog>
    <el-drawer
      class="drawer-container"
      :with-header="false"
      :visible.sync="drawerVisible"
      size="400"
      direction="rtl"
    >
      <div class="question-drawer">
        <div>
          题目列表
        </div>
        <div class="mt-12 mb-12">
          <el-select
            class="w-120 mr-12"
            size="small"
            placeholder="请选择状态"
            v-model="status"
            clearable
            @change="handleSearch"
          >
            <el-option label="待校对" :value="1"></el-option>
            <el-option label="已校对" :value="2"></el-option>
            <el-option label="已拒绝" :value="3"></el-option>
            <el-option label="已通过" :value="4"></el-option>
          </el-select>
          <el-button type="primary" size="mini" plain @click="handleSearch"
            >查询</el-button
          >
          <el-button size="mini" @click="handleClearSearch">重置</el-button>
        </div>
        <el-table
          :data="questionStatusList"
          stripe
          style="width: 100%"
          v-loading="drawerLoading"
        >
          <el-table-column
            prop="skill_question_id"
            label="题目编号"
            width="100"
          >
          </el-table-column>
          <el-table-column label="审核状态" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">
                <el-tag type="warning" size="small">待校对</el-tag>
              </span>
              <span v-if="scope.row.status == 2">
                <el-tag size="small">已校对</el-tag>
              </span>
              <span v-if="scope.row.status == 3">
                <el-tag type="danger" size="small">已拒绝</el-tag>
              </span>
              <span v-if="scope.row.status == 4">
                <el-tag size="small">已通过</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                @click="getQuestionDetail(scope.row.skill_question_id)"
                v-if="
                  authPermissions.includes(
                    'question.api.fuwu_admin.skill_question_verify_tasks.question_statuses.index'
                  )
                "
              >
                详情</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          @current-change="getQuestionStatusList"
          :current-page.sync="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          :hide-on-single-page="true"
        >
        </el-pagination>
        <div
          v-if="
            taskInfo.status == 2 &&
              authPermissions.includes(
                'question.api.fuwu_admin.skill_question_verify_tasks.pass'
              )
          "
          class="submit-btn-container"
        >
          <zhu-button
            class="submit-btn w-200"
            text="校对完成，提交审核"
            :shadow="true"
            type="primary"
            :loading="btnLoading"
            @click="submitTask"
          >
          </zhu-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="提示" :visible.sync="dialogSubmitVisible" width="30%">
      <div>
        <el-alert type="success" show-icon :closable="false"
          >当前该任务下所有题目已校对完成，是否提交审核</el-alert
        >
      </div>
      <span
        v-if="
          authPermissions.includes(
            'question.api.fuwu_admin.skill_question_verify_tasks.pass'
          )
        "
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogSubmitVisible = false" :loading="btnLoading"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitTask" :loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import Markdown from "@/components/Markdown";
import skillService from "@/global/service/skill";

export default {
  components: {
    MarkdownIt,
    Markdown
  },
  data() {
    return {
      loading: false,
      btnLoading: false,
      drawerLoading: false,
      proofreadLoading: false,
      dialogDesVisible: false,
      dialogSubmitVisible: false,
      drawerVisible: false,
      dialogDescription: "",
      status: null,
      langsFlag: null,
      skillQuestionIdFlag: null,
      taskInfo: {},
      proofreadInfo: {},
      originInfo: {},
      questionStatusList: [],
      verify_histories: [],
      proofreadRules: {
        stem: { required: true, trigger: "blur" },
        analysis: { required: true, trigger: "blur" }
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    originInfoTipsType() {
      let type = "warning";
      if (this.originInfo.status == 3) {
        type = "warning";
      } else if (this.originInfo.status == 2 || this.originInfo.status == 4) {
        type = "success";
      }
      return type;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      this.loading = true;
      skillService.proofreadTaskItem(id).then(res => {
        this.taskInfo = res;
        this.langsFlag = res.langs == 2 ? "en" : "fr";
        this.skillQuestionIdFlag = res.skill_question_id;
        this.getQuestionNext();
      });
      // .finally(() => {
      //   this.loading = false;
      // });
    },
    getQuestionNext() {
      const id = this.$route.params.id;
      this.loading = true;
      this.proofreadLoading = true;
      skillService
        .proofreadQuestionNext(id)
        .then(res => {
          if (res.has_wait_handle_question) {
            this.dealQuestionData(res);
          } else {
            this.dialogSubmitVisible = this.taskInfo.status == 2 ? true : false;
            this.getQuestionDetail(this.skillQuestionIdFlag);
          }
        })
        .finally(() => {
          this.loading = false;
          this.proofreadLoading = false;
        });
    },
    getQuestionDetail(id) {
      const task_id = this.$route.params.id;
      this.loading = true;
      this.proofreadLoading = true;
      skillService
        .proofreadQuestionItem(task_id, id)
        .then(res => {
          this.dealQuestionData(res);
        })
        .finally(() => {
          this.loading = false;
          this.proofreadLoading = false;
          this.drawerVisible = false;
        });
    },
    dealQuestionData(res) {
      this.verify_histories = res.verify_histories || [];
      this.originInfo = {
        status: res.status,
        status_label: res.status_label,
        id: res.skill_question.id
      };

      if (res.skill_question.translator["zh-cn"]) {
        this.originInfo.stem = res.skill_question.translator["zh-cn"].stem;
        this.originInfo.analysis =
          res.skill_question.translator["zh-cn"].analysis;
      }

      this.originInfo.options = res.skill_question.options.map(data => {
        return {
          option: data.translator["zh-cn"]
            ? data.translator["zh-cn"].option
            : ""
        };
      });
      const langsFlag = this.langsFlag;
      const proofreadOptions = res.skill_question.options.map(data => {
        return {
          option: data.translator[`${langsFlag}`]
            ? data.translator[`${langsFlag}`].option
            : "",
          id: data.id
        };
      });

      this.proofreadInfo = {
        stem:
          res.skill_question.translator[`${langsFlag}`] &&
          res.skill_question.translator[`${langsFlag}`].stem
            ? res.skill_question.translator[`${langsFlag}`].stem
            : "",
        analysis:
          res.skill_question.translator[`${langsFlag}`] &&
          res.skill_question.translator[`${langsFlag}`].analysis
            ? res.skill_question.translator[`${langsFlag}`].analysis
            : "",
        options: proofreadOptions
      };
    },
    handleOpenDrawer() {
      this.drawerVisible = true;
      this.status = null;
      this.getQuestionStatusList();
    },
    getQuestionStatusList() {
      const id = this.$route.params.id;
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        status: this.status
      };
      this.drawerLoading = true;
      skillService
        .proofreadQuestionStatus(id, params)
        .then(res => {
          this.allQuestionCheck = true;
          this.questionStatusList = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.drawerLoading = false;
        });
    },
    submitTask() {
      const id = this.$route.params.id;
      this.btnLoading = true;
      this.$confirm("确认提交？")
        .then(() => {
          skillService
            .proofreadTaskPass(id)
            .then(() => {
              this.$message.success("已提交该任务");
              this.$router.push({
                name: "QuestionProofreadMySelf"
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    proofreadFinish() {
      if (this.btnLoading) return;
      this.$refs["proofreadInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        this.btnLoading = true;
        const question_id = this.originInfo.id;
        const id = this.$route.params.id;
        const proofreadOptions = this.proofreadInfo.options.map(data => {
          return {
            id: data.id,
            translator: {
              [`${this.langsFlag}`]: {
                option: data.option
              }
            }
          };
        });
        const params = {
          translator: {
            [`${this.langsFlag}`]: {
              stem: this.proofreadInfo.stem,
              analysis: this.proofreadInfo.analysis
            }
          },
          options: proofreadOptions
        };
        skillService
          .proofreadQuestionVerify(id, question_id, params)
          .then(() => {
            this.$message.success("该题目已完成校对");
            this.getData();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getQuestionStatusList();
    },
    handleClearSearch() {
      this.status = null;
      this.pagination.currentPage = 1;
      this.getQuestionStatusList();
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.min-h-154 {
  .md {
    min-width: 0;
    .v-left-item {
      flex: none;
    }
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.proofread-card-container {
  display: flex;
  align-items: stretch;
  justify-content: center;
  align-content: center;
  .origin-card {
    width: 30%;
  }
  .proofread-card {
    width: 70%;
  }
}
.basic-info {
  margin-bottom: 12px;
  font-size: 14px;
  .label {
    display: inline-block;
    width: 90px;
    text-align: right;
  }
}
.question-info {
  margin-top: 12px;
  .question-item {
    margin-bottom: 22px;
    font-size: 14px;
    .question-label {
      display: inline-block;
      text-align: left;
      padding: 0 0 10px;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
    }
    .question-content {
      color: #303133;
      line-height: 40px;
      border-radius: 4px;
      text-align: justify;
      padding: 10px;
      background-color: #fafafa;
      &.question-stem {
        background-color: #ecf5ff;
      }
      &.question-analysis {
        background-color: #fff8ee;
      }
    }
  }
}
.submit-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 36px;
  margin-top: 36px;
}
.question-drawer {
  padding: 20px;
  .question-info {
    margin: 20px 0;
  }
}
.finish-btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
/deep/.drawer-container .el-drawer__body {
  overflow: auto;
}
</style>
